import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import DashboardLayout from './DashboardLayout ';
import JobTypeOptions from './JobTypeOptions';
import LocationPicker from './LocationPicker';
import axios from 'axios';
import CreatableSelect from 'react-select/creatable';

const EvergreenJobForm = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    const companyName = userFromLocalStorage?.companyName;
    const navigate = useNavigate();
    const location = useLocation();
    const { userName, userEmail, jobCategory } = location.state || {};
    const today = new Date().toISOString().split('T')[0];
    const [selectedLocs, setSelectedLocs] = useState([]);
    const [suggestedSkills, setSuggestedSkills] = useState([]);
    const [showSuggestedSkills, setShowSuggestedSkills] = useState(true); // <-- toggle state

    const [isLeftSideVisible, setIsLeftSideVisible] = useState(true);
    const [formData, setFormData] = useState({
        hrEmail: userEmail || '',
        jobTitle: '',
        jobType: '',
        location: '',
        salary: '30000',
        postingDate: today,
        jobsummary: '',
        jobCategory: jobCategory,  // Set initial jobCategory
        skills: []
    });

    const toggleLeftSide = () => {
        setIsLeftSideVisible(!isLeftSideVisible);
    };

    useEffect(() => {
        setFormData(prevState => ({
            ...prevState,
            userEmail: userEmail || '',
        }));
    }, [userEmail]);

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            location: selectedLocs.join(', ')
        }));
    }, [selectedLocs]);
    const handleSubmit = async (event) => {
        if (event) event.preventDefault();
        const updatedFormData = {
            ...formData,
            skills: formData.skills.join(', '), // Convert array to comma-separated string
            location: selectedLocs.join(', '),

        };
        try {
            const response = await saveJobData(updatedFormData);
            if (response.ok) {
                await Swal.fire({
                    icon: "success",
                    title: "Job post Successful!",
                    text: "You have successfully posted this job."
                });
                navigate('/hr-dashboard/all-jobs', { state: { userName: userName, userEmail: userEmail, selectedTab: 'evergreenjobs' } });
            } else {
                throw new Error('Job submission failed');
            }
        } catch (error) {
        }
    };

    const saveJobData = async (formData) => {
        try {
            const response = await fetch(`${BASE_API_URL}/postingJob`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });
            return response;
        } catch (error) {
            throw new Error("Invalid Job details");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleBack = () => {
        navigate('/hr-dashboard/my-jobs', { state: { userName: userName, userEmail: userEmail, selectedTab: 'evergreenJobs' } });
        // navigate(-1);
    };
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 767);

    useEffect(() => {
        // Update the `isSmallScreen` state based on screen resizing
        const handleResize = () => setIsSmallScreen(window.innerWidth <= 767);

        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLocationChange = (locs, country) => {
        setSelectedLocs(locs);
        setFormData(f => ({
            ...f,
            countryCode: country,
            location: locs.join(', '),
        }));
    };

    const handleJobTitleBlur = async () => {
        const jobTitle = formData.jobTitle;
        if (jobTitle && jobTitle.length > 3) {
            const suggested = await fetchSkillsForJobTitle(jobTitle);
            setSuggestedSkills(suggested);
        }
    };

    const fetchSkillsForJobTitle = async (jobTitle) => {
        try {
            const response = await axios.get(`${BASE_API_URL}/skills`, {
                params: { jobTitle }
            });
            return response.data; // Array of skills
        } catch (error) {
            console.error('Error fetching skills:', error);
            return [];
        }
    };
    return (
        <DashboardLayout>
            <div className="main-content">
                <Card style={{ marginTop: '5px', width: '98%', marginLeft: '10px' }}>
                    <Card.Header>
                        <Card.Title className="mb-0" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <h3 style={{ fontSize: '25px', margin: 0 }}>Post Evergreen Job</h3>
                            <p style={{ margin: 0 }}>
                                (Create a job posting that remains open indefinitely, always open for hiring with no due date)
                            </p>
                        </Card.Title>
                    </Card.Header>

                    <Form onSubmit={handleSubmit}>
                        <Card.Body>
                            <Row style={{ marginBottom: '24px' }}>
                                <Col md={6}>
                                    <Form.Group controlId="jobTitle">
                                        <Form.Label className="required-label">Job Title:</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="jobTitle"
                                            value={formData.jobTitle}
                                            onChange={handleChange}
                                            onBlur={handleJobTitleBlur}
                                            placeholder='Eg: Java Developer , Software Developer , Full Stack Developer'
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="jobType">
                                        <Form.Label className="required-label">Job Type:</Form.Label>
                                        <Form.Select
                                            className="form-jobType"
                                            name="jobType"
                                            value={formData.jobType}
                                            onChange={handleChange}
                                            required
                                        >
                                            {JobTypeOptions.map((type, index) => (
                                                <option key={index} value={type}>{type}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: '24px' }}>
                                <Col md={6}>
                                    <Form.Group controlId="postingDate">
                                        <Form.Label className="required-label">Posting Date:</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="postingDate"
                                            value={formData.postingDate}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="skills">
                                        <Form.Label className="required-label">Skills:</Form.Label>
                                        <CreatableSelect
                                            isMulti
                                            value={formData.skills.map(skill => ({ label: skill, value: skill }))}
                                            onChange={(selectedOptions) =>
                                                setFormData({ ...formData, skills: selectedOptions.map(opt => opt.value) })
                                            }
                                            placeholder="Eg: Java, Python, React"
                                        />
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
                                            <Form.Text className="text-muted">
                                                * Suggested skills based on job title. Click to add:
                                            </Form.Text>
                                            <Button
                                                variant="link"
                                                size="sm"
                                                style={{ padding: 0, fontSize: '0.9rem' }}
                                                onClick={() => setShowSuggestedSkills(prev => !prev)}
                                            >
                                                {showSuggestedSkills ? 'Hide' : 'Show'}
                                            </Button>
                                        </div>

                                        {showSuggestedSkills && (
                                            <div style={{ marginTop: '5px' }}>
                                                {suggestedSkills.map((skill, idx) => (
                                                    <Button
                                                        key={idx}
                                                        variant="outline-secondary"
                                                        size="sm"
                                                        style={{ margin: '4px' }}
                                                        onClick={() => {
                                                            if (!formData.skills.includes(skill)) {
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    skills: [...prev.skills, skill],
                                                                }));
                                                            }
                                                        }}
                                                    >
                                                        {skill}
                                                    </Button>
                                                ))}
                                            </div>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row style={{ marginBottom: '24px' }}>
                                <Col md={6}>
                                    <Form.Group controlId="salary">
                                        <Form.Label className="required-label">Salary:</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="salary"
                                            value={formData.salary}
                                            onChange={handleChange}
                                            required
                                            placeholder='Enter Salary'
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    {/* <Form.Group controlId="location">
                                        <Form.Label className="required-label">Location :</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="location"
                                            value={formData.location}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group> */}
                                    <LocationPicker
                                        companyName={companyName}
                                        apiUrl={BASE_API_URL}
                                        initialCountry="IN"
                                        initialSelection={selectedLocs}
                                        onChange={handleLocationChange}
                                    />
                                </Col>
                            </Row>
                            <Form.Group controlId="jobsummary">
                                <Form.Label className="required-label">Job summary: (Add Additional Information)</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="jobsummary"
                                    value={formData.jobsummary}
                                    onChange={handleChange}
                                    className="fullWidthTextarea"
                                    style={{ minHeight: '150px' }}
                                    required
                                />
                            </Form.Group>
                        </Card.Body>
                        <Card.Footer>
                            <div className="d-flex justify-content-center">
                                <Button type="submit" className="btn btn-primary m-1">
                                    Post Job
                                </Button>
                                <Button className="btn btn-light m-1" onClick={handleBack}>Back</Button>
                            </div>
                        </Card.Footer>
                    </Form>
                </Card>
            </div>

        </DashboardLayout>
    );
}

export default EvergreenJobForm;
